import { Enum } from 'enumify-mod';

class RegistrationStep extends Enum {
	static CUSTOMER;
	static PAYMENT;
	static SUMMARY;
}

RegistrationStep.initEnum({
	CUSTOMER: 'Customer',
	PAYMENT: 'Payment',
	SUMMARY: 'Summary'
});

export default RegistrationStep;


// WEBPACK FOOTER //
// ./enums/RegistrationStep.js